"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleUpdatePrintableDesign;
const either_1 = require("../../../types/either");
const UpdatePrintableDesign_1 = require("../../../actions/UpdatePrintableDesign");
const updatePrintableDesign_1 = __importDefault(require("../updatePrintableDesign"));
const updateProjectVersion_1 = __importDefault(require("../updateProjectVersion"));
function handleUpdatePrintableDesign(project, action, dependencies) {
  return __awaiter(this, void 0, void 0, function* () {
    if (!(0, UpdatePrintableDesign_1.isUpdatePrintableDesign)(action)) {
      return (0, either_1.left)(new Error('Action does not match update printable design schema'));
    }
    const {
      getTemplate,
      getART
    } = dependencies;
    const template = yield getTemplate(project.product.sku, project.product.options, 'live');
    if (template.isLeft()) {
      return (0, either_1.left)(new Error(`Error fetching template for designId: ${action.designId}, with sku: ${project.product.sku}, options: ${project.product.options}, received: ${template.value}`));
    }
    const artResult = yield getART(project.product.sku);
    if (artResult.isLeft()) {
      return (0, either_1.left)(artResult.value);
    }
    const newProject = (0, updateProjectVersion_1.default)(project, action);
    return (0, updatePrintableDesign_1.default)(newProject, action, template.value, artResult.value);
  });
}